import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import { Text } from 'components/core/Typography';
import { Tooltip } from 'components/core/Tooltip';

import DropdownIcon from 'components/svg/Dropdown';
import './FeeWarningToolTip.scss';

function FeeWarningToolTip({
	feeProps,
	className,
	triggerAlignment = 'center',
	variation = false,
}) {
	const fees = [
		{ name: 'One-Time Admin Fee', price: feeProps?.admin?.value },
		{ name: 'One-Time Lock Fee', price: feeProps?.lock?.value },
	].filter((fee) => fee.price > 0);
	const totalFees = feeProps?.totalFees.value;
	return (
		<Tooltip
			className={classnames('tooltip-banner', className)}
			content={
				<Text
					size="tiny"
					color="gray"
				>
					The following fees shall apply:
					{fees && (
						<ul>
							{fees.map((fee) => (
								<li key={fee.name}>
									{`${fee.name}: $${fee.price}`}
								</li>
							))}
						</ul>
					)}
				</Text>
			}
			clickOnMobile
			fillParentContainer={triggerAlignment}
			simpleButton
			as="div"
		>
			<Text
				last
				size="tiny"
				color={variation ? 'black' : 'gray'}
				className="total-fee-text"
				weight={variation ? 'bold' : 'standard'}
			>
				+ ${totalFees} in fees <DropdownIcon />
			</Text>
		</Tooltip>
	);
}

FeeWarningToolTip.propTypes = {
	feeProps: PropTypes.object.isRequired,
	className: PropTypes.string,
	triggerAlignment: PropTypes.string,
	variation: PropTypes.bool,
};

export default FeeWarningToolTip;
